import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { HrmPersonnel } from "../../models/hrm-personnel.model";
import { PersonnelPhoto } from "../../models/personnel-photo.model";

@Component({
  selector: "ngx-hrm-personnel-form",
  templateUrl: "./hrm-personnel-form.component.html",
  styleUrls: ["./hrm-personnel-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrmPersonnelFormComponent extends BaseFormComponent<HrmPersonnel> {
  DefaultValues: Dictionary = [];
  PersCodeLen: number;
  PersonnelPhotocolumns: form_control[];
  PersonnelFightercolumns: form_control[];
  PersonnelOtherInfos: form_control[];
  PersonnelServiceds: form_control[];
  PersonnelWorkRecordss: form_control[];
  PersonnelStudyRecords: form_control[];
  PersonnelLanguages: form_control[];
  PersonnelRecommenders: form_control[];
  PersonnelRelativess: form_control[];
  PersonnelAddresss: form_control[];
  public formGroupPhoto: UntypedFormGroup;
  public formGroupPersonnelFighter: UntypedFormGroup;
  public apiName: string = "HrmPersonnel";
  public label: string = "معرفی کارکنان";
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private missetup: MisSetupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.defaultCoumnNumber = 6;
    if (!this.PersCodeLen) this.PersCodeLen = this.missetup.getnumber("HRM", "PersCodeLen");
    super.ngOnInit();
    this.DefaultValues["HrmPersonnelId"] = 0;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DefaultValues = undefined;
    this.PersonnelPhotocolumns = undefined;
    this.PersonnelFightercolumns = undefined;
    this.formGroupPhoto = undefined;
    this.formGroupPersonnelFighter = undefined;
    this.PersonnelOtherInfos = undefined;
    this.PersonnelServiceds = undefined;
    this.PersonnelWorkRecordss = undefined;
    this.PersonnelStudyRecords = undefined;
    this.PersonnelLanguages = undefined;
    this.PersonnelRecommenders = undefined;
    this.PersonnelRelativess = undefined;
    this.PersonnelAddresss = undefined;
  }
  setdefault() {
    if (!this.model.PersonnelAddresss) this.model.PersonnelAddresss = [];
    if (!this.model.PersonnelOtherInfos) this.model.PersonnelOtherInfos = [];
    if (!this.model.PersonnelRecommenders) this.model.PersonnelRecommenders = [];
    if (!this.model.PersonnelRelativess) this.model.PersonnelRelativess = [];
    if (!this.model.PersonnelServiceds) this.model.PersonnelServiceds = [];
    if (!this.model.PersonnelStudyRecords) this.model.PersonnelStudyRecords = [];
    if (!this.model.PersonnelWorkRecordss) this.model.PersonnelWorkRecordss = [];
    if (!this.model.PersonnelLanguages) this.model.PersonnelLanguages = [];
    if (!this.model.PersonnelEducations) this.model.PersonnelEducations = [];
    if (!this.model?.PersonnelPhoto) {
      this.setPersonnelPhotocolumns();
    }
    if (!this.model.PersonnelFighter) {
      this.setPersonnelFightercolumns;
    }
    this.cd.markForCheck();
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    if (this.PersCodeLen) this.columns.find((x) => x.name === "PersCode").maxLength = this.PersCodeLen;
    this.PersonnelFightercolumns = this.getDetailControlModels("formGroupPersonnelFighter");
    this.PersonnelOtherInfos = this.getDetailControlModels("PersonnelOtherInfos");
    this.PersonnelOtherInfos = this.getDetailControlModels("PersonnelOtherInfos");
    this.PersonnelWorkRecordss = this.getDetailControlModels("PersonnelWorkRecordss");
    this.PersonnelStudyRecords = this.getDetailControlModels("PersonnelStudyRecords");
    this.PersonnelLanguages = this.getDetailControlModels("PersonnelLanguages");
    this.PersonnelRecommenders = this.getDetailControlModels("PersonnelRecommenders");
    this.PersonnelRelativess = this.getDetailControlModels("PersonnelRelativess");
    this.PersonnelAddresss = this.getDetailControlModels("PersonnelAddresss");
    this.PersonnelServiceds = this.getDetailControlModels("PersonnelServiceds");
  }
  setPersonnelFightercolumns() {
    this.formGroupPersonnelFighter = this.setFormGroup(this.model.PersonnelFighter, this.PersonnelFightercolumns);
  }
  setPersonnelPhotocolumns() {
    this.httpCommonService
      .get("HrmPersonnel/GetPhtoEntityInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.model.PersonnelPhoto = <PersonnelPhoto>{};
        this.PersonnelPhotocolumns = this.getDetailControlModels("PersonnelPhoto");
        this.formGroupPhoto = this.setFormGroup(this.model.PersonnelPhoto, this.PersonnelPhotocolumns);
      });
  }
  onChanged($event) {
    if (!this.model.PersCode && this.formGroup && !this.formGroup.get("PersCode").valid) {
      if ($event && $event.apiName === "PeopleInfo/GetPagining") {
        this.model.PersCode = $event.data.DetailLedgerCode;
        this.setValue("PersCode", this.model.PersCode);
      }
    }
  }
  beforupdate() {
    if (!this.model.PersonnelEducations || this.model.PersonnelAddresss.length <= 0) this.model.PersonnelEducations = undefined;
    else
      this.setValue(
        "PersonnelEducations",
        this.model.PersonnelEducations.filter((x) => x.State !== RowState.Detached)
      );
    if (!this.model.PersonnelAddresss || this.model.PersonnelAddresss.length <= 0) this.model.PersonnelAddresss = undefined;
    else
      this.setValue(
        "PersonnelAddresss",
        this.model.PersonnelAddresss.filter((x) => x.State !== RowState.Detached)
      );
    if (!this.model.PersonnelOtherInfos || this.model.PersonnelOtherInfos.length <= 0) this.model.PersonnelOtherInfos = undefined;
    else
      this.setValue(
        "PersonnelOtherInfos",
        this.model.PersonnelOtherInfos.filter((x) => x.State !== RowState.Detached)
      );

    if (!this.model.PersonnelRecommenders || this.model.PersonnelRecommenders.length <= 0) this.model.PersonnelRecommenders = undefined;
    else
      this.setValue(
        "PersonnelRecommenders",
        this.model.PersonnelRecommenders.filter((x) => x.State !== RowState.Detached)
      );

    if (!this.model.PersonnelRelativess || this.model.PersonnelRelativess.length <= 0) this.model.PersonnelRelativess = undefined;
    else
      this.setValue(
        "PersonnelRelativess",
        this.model.PersonnelRelativess.filter((x) => x.State !== RowState.Detached)
      );

    if (!this.model.PersonnelServiceds) this.model.PersonnelServiceds = undefined;
    else this.setValue("PersonnelServiceds", this.model.PersonnelServiceds);

    if (!this.model.PersonnelStudyRecords || this.model.PersonnelStudyRecords.length <= 0) this.model.PersonnelStudyRecords = undefined;
    else
      this.setValue(
        "PersonnelStudyRecords",
        this.model.PersonnelStudyRecords.filter((x) => x.State !== RowState.Detached)
      );

    if (!this.model.PersonnelWorkRecordss || this.model.PersonnelWorkRecordss.length <= 0) this.model.PersonnelWorkRecordss = undefined;
    else
      this.setValue(
        "PersonnelWorkRecordss",
        this.model.PersonnelWorkRecordss.filter((x) => x.State !== RowState.Detached)
      );

    if (!this.model.PersonnelLanguages || this.model.PersonnelLanguages.length <= 0) this.model.PersonnelLanguages = undefined;
    else
      this.setValue(
        "PersonnelLanguages",
        this.model.PersonnelLanguages.filter((x) => x.State !== RowState.Detached)
      );
  }
}
